import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createSystemInvoiceAction } from "../actions/create-system-invoice";
import { ICreateInvoicePayload } from "../interfaces/invoice.interfaces";
import { useSelector } from "react-redux";

export const useCreateSystemInvoiceMutation = () => {
  const queryClient = useQueryClient();
  const { company } = useSelector((state: any) => state.userState);

  return useMutation({
    mutationFn: (invoice: ICreateInvoicePayload) => {
      if (!company?.id) {
        throw new Error("Company ID is required");
      }
      return createSystemInvoiceAction(invoice, company.id);
    },
    onSuccess: (data) => {
      // Invalidate general invoice queries
      queryClient.invalidateQueries({ queryKey: ["invoices"] });
      queryClient.invalidateQueries({ queryKey: ["invoice-list"] });
      queryClient.invalidateQueries({ queryKey: ["invoice-metrics"] });
      if (data?.uid) {
        queryClient.invalidateQueries({ queryKey: ["invoice", data.uid] });
      }
    },
    onError: (error: any) => {
      console.error("[useCreateSystemInvoiceMutation] Error creating system invoice:", error);
    },
  });
};
